import _ from 'lodash';
import { ActionTypes } from '../actions/cardListingActions';

const initialState = {
  busy: false,
  products: [],
  limit: 12,
  filters: {
    type: 'PRINT_MEDIA',  // WE ONLY LOAD PRINT FOR PLP
    active_only: true,
    has_foil: false,
    has_custom_photo: false,
    color: null
  },
  allColors: [],
  activeSkus: {},
  isAdminView: false,
};

const cardListing = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_CARDS: {
      return { ...state, busy: true, products: [] };
    }
    case ActionTypes.RECEIVE_CARDS: {
      const { products, limit, allColors, hasFoil } = action.payload;  // eslint-disable-line
      const stateColors = _.union(state.allColors, allColors).sort();
      return {
        ...state,
        busy: false,
        products,
        limit,
        allColors: _.union(stateColors, allColors).sort(),
      };
    }
    case ActionTypes.REQUEST_MORE_CARDS: {
      return { ...state, busy: true };
    }
    case ActionTypes.RECEIVE_MORE_CARDS: {
      const { products, limit, allColors } = action.payload;
      return {
        ...state,
        busy: false,
        products: [...state.products, ...products],
        limit,
        allColors: _.union(state.allColors, allColors).sort(),
      };
    }
    case ActionTypes.LISTING_CARD_TYPE_CHANGE: {
      const cardType = action.payload;
      if (cardType !== state.filters.card_type) {
        return { ...state, filters: { ...state.filters, type: 'PRINT_MEDIA', card_type: cardType } };
      }
      return { ...state, filters: { ...state.filters, card_type: cardType } };
    }
    case ActionTypes.LISTING_CARD_ACTIVE_CHANGE: {
      return { ...state, filters: { ...state.filters, active_only: action.payload } };
    }
    case ActionTypes.LISTING_CARD_COLORS_CHANGE: {
      return { ...state, filters: { ...state.filters, color: action.payload } };
    }
    case ActionTypes.LISTING_CARD_BOOLEAN_FILTER_CHANGE: {
      const { filterName, value } = action.payload;
      return { ...state, filters: { ...state.filters, [filterName]: value } };
    }
    case ActionTypes.LISTING_RESET_FILTERS: {
      const currentActiveOnly = state.filters.active_only;
      return { ...state, filters: { ...initialState.filters, active_only: currentActiveOnly } };
    }
    case ActionTypes.LISTING_CARD_DETAIL_SKU_CHANGE: {
      const { productId, skuId } = action.payload;
      return { ...state, activeSkus: { ...state.activeSkus, [productId]: skuId } };
    }
    case ActionTypes.LISTING_ADMIN_VIEW: {
      return { ...state, isAdminView: action.payload.isAdminView };
    }
    default:
      return state;
  }
};

export default cardListing;



/** WEBPACK FOOTER **
 ** ./src/cards/reducers/cardListing.js
 **/